import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

const proyectosImages = [
  { id: 1, image: '/imagenes/tatuajes/animal-1-tigre.jpg' },
  { id: 2, image: '/imagenes/tatuajes/retrato-1-antebrazo.jpg' },
  { id: 3, image: '/imagenes/tatuajes/blackwork-1-geometrico.jpg' }
];

export const ProyectosRecientes = () => {
  const { t } = useLanguage();
  
  return (
    <section id="proyectos" className="py-20 lg:py-32 bg-[#111111]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-light text-[#F5F5F5] tracking-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
            data-testid="proyectos-title"
          >
            {t.proyectos.title}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {proyectosImages.map((proyecto, index) => (
            <motion.div
              key={proyecto.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
              className="group"
              data-testid={`proyecto-${proyecto.id}`}
            >
              <div className="relative overflow-hidden bg-[#1C1C1C] aspect-square mb-4">
                <img
                  src={proyecto.image}
                  alt={t.proyectos.items[index]}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <p className="text-sm text-[#9CA3AF] tracking-wide text-center">
                {t.proyectos.items[index]}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
